import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './UserDialog.css';



const UserDialog = ({ open, onClose, onSave, user, setUser, isRtl }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const listOfStatus = [
        { label: t('active'), value: 1 },
        { label: t('disabled'), value: 2 }
    ];
    const listOfRoles = [
        { label: t('admin'), value: 1 },
        { label: t('airPort'), value: 2 }
    ];

    const handleChange = (field, value) => {
        setUser(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: '' }));
    };

    const validate = () => {
        let newErrors = {};
        if (user.Id === 0 && !user.UID) newErrors.UID = t('requiredField');
        if (user.Id === 0 && !user.Password) newErrors.Password = t('requiredField');
        if (!user.Name) newErrors.Name = t('requiredField');
        if (!user.Email) newErrors.Email = t('requiredField');
        return newErrors;
    };

    const handleSave = () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        onSave(user);
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center px-4">
            <div
                className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6"
                style={{ direction: isRtl ? 'rtl' : 'ltr' }}
            >
                <h2 className="text-2xl font-semibold mb-6 text-gray-800">{t('addNewUser')}</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className='sm:col-span-2'>
                        <label className="block mb-1 text-gray-700 font-medium">{t('name')}</label>
                        <input
                            autoFocus
                            type="text"
                            placeholder={t('username')}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                            value={user.Name}
                            onChange={e => handleChange('Name', e.target.value)}
                        />
                        {errors.Name && (<p className="text-red-500 text-sm mt-1">{errors.Name}</p>)}
                    </div>

                    {!user.Id && (
                        <>
                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('uid')}</label>
                                <input
                                    type="text"
                                    placeholder={t('uid')}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                                    value={user.UID}
                                    onChange={e => handleChange('UID', e.target.value)}
                                />
                                {errors.UID && (<p className="text-red-500 text-sm mt-1">{errors.UID}</p>)}
                            </div>
                            <div>
                                <label className="block mb-1 text-gray-700 font-medium">{t('pwd')}</label>
                                <input
                                    type="password"
                                    placeholder={t('pwd')}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                                    value={user.Password}
                                    onChange={e => handleChange('Password', e.target.value)}
                                />
                                {errors.Password && (<p className="text-red-500 text-sm mt-1">{errors.Password}</p>)}
                            </div>
                        </>
                    )}

                    <div>
                        <label className="block mb-1 text-gray-700 font-medium">{t('phone')}</label>
                        <input
                            type="text"
                            placeholder={t('phone')}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                            value={user.Phone}
                            onChange={e => handleChange('Phone', e.target.value)}
                        />
                        {errors.Phone && (<p className="text-red-500 text-sm mt-1">{errors.Phone}</p>)}
                    </div>

                    <div>
                        <label className="block mb-1 text-gray-700 font-medium">{t('mobile')}</label>
                        <input
                            type="text"
                            placeholder={t('mobile')}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                            value={user.Mobile}
                            onChange={e => handleChange('Mobile', e.target.value)}
                        />
                        {errors.Mobile && (<p className="text-red-500 text-sm mt-1">{errors.Mobile}</p>)}
                    </div>

                    <div className="sm:col-span-2">
                        <label className="block mb-1 text-gray-700 font-medium">{t('email')}</label>
                        <input
                            type="email"
                            placeholder={t('email')}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                            value={user.Email}
                            onChange={e => handleChange('Email', e.target.value)}
                        />
                        {errors.Email && (<p className="text-red-500 text-sm mt-1">{errors.Email}</p>)}
                    </div>

                    <div>
                        <label className="block mb-1 text-gray-700 font-medium">{t('role')}</label>
                        <select
                            id="role"
                            value={user.Role}
                            onChange={e => handleChange('Role', e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="">{t('select')}</option>
                            {listOfRoles.map(role => (
                                <option key={role.value} value={role.value}>
                                    {role.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 text-gray-700 font-medium">{t('status')}</label>
                        <select
                            id="status"
                            value={user.StatusId}
                            onChange={e => handleChange('StatusId', e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="">{t('select')}</option>
                            {listOfStatus.map(status => (
                                <option key={status.value} value={status.value}>
                                    {status.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                    <button
                        onClick={() => {
                            setSubmitted(true);
                            handleSave();
                        }}
                        disabled={loading}
                        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                        {loading ? t('saving') : t('save')}
                    </button>

                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 transition focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                        {t('cancel')}
                    </button>
                </div>
            </div>
        </div>
    );


};

export default UserDialog;